<template>
  <basic-container>
    <avue-crud
      :option="option"
      :search.sync="searchForm"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft"> </template>
      <template slot-scope="scope" slot="spaceCodesForm">
        <el-select
          v-model="form.spaceCodes"
          multiple
          multiple-limit="5"
          filterable
          placeholder="请选择 车位编号"
        >
          <el-option
            v-for="item in spaceList"
            :key="item.parkSpaceNo"
            :label="item.parkSpaceNo"
            :value="item.parkSpaceNo"
          >
          </el-option>
        </el-select>
      </template>
      <!--新增月卡车-->
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-setting"
          v-if="permissionList.add_carMonthBtn"
          @click="openAddCarmonthDialog(scope.row)"
        >
          新增月卡车
        </el-button>
      </template>
      <template slot="plateNumber" slot-scope="scope">
        <wq-overHidden :content="scope.row.plateNumber">
          <span>{{ scope.row.plateNumber }}</span>
        </wq-overHidden>
      </template>
      <template slot="roomName" slot-scope="scope">
        <wq-overHidden :content="scope.row.roomName">
          <span>{{ scope.row.roomName }}</span>
        </wq-overHidden>
      </template>
      <template slot="remark" slot-scope="scope">
        <wq-overHidden :content="scope.row.remark">
          <span>{{ scope.row.remark }}</span>
        </wq-overHidden>
      </template>
    </avue-crud>

    <el-dialog
      title="新增月卡车"
      :visible.sync="addCarMonthShowDialogFlag"
      :modal-append-to-body="false"
      @close="quitAddCarMonthDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="addCarMonthFormRef"
          v-model="addCarMonthForm"
          :option="addCarmonthOption"
          @submit="addCarMonthSubmit"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitAddCarMonthDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  getSpaceList,
  remove,
  update,
  syncDrivers,
  removeCar,
} from '@/api/v4ward/park/driverv2/parkdriver';
import {
  addCarMonthNew,
  getcarMonthLastEndTime,
  carMonthRule,
} from '@/api/v4ward/park/vehiclev2/parkvehicle';
import { getDetailById as getCarParkspace } from '@/api/v4ward/carv2/carpark';
import { monthChargeRuleListV2 } from '@/api/v4ward/carv2/carmonthchargerule';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { mapGetters } from 'vuex';
import addCarmonthOption from '../vehiclev2/parkvehicle-addCarmonth';
import { nodeTreeByParentId, loadCarPayAmount } from '@/api/v4ward/carv2/carmonth';
import dayjs from 'dayjs';
export default {
  data() {
    var validateCarInfos = (rule, value, callback) => {
      for (let key in value) {
        let ele = value[key];
        if (this.vdui.isEmpty(ele.plateNumber)) {
          callback(new Error('请输入车牌！'));
          return;
        } else if (!this.$validation.carPlate.test(ele.plateNumber)) {
          callback(new Error('车牌格式不正确！'));
          return;
        }
        if (this.vdui.isEmpty(ele.vehicleType)) {
          callback(new Error('车辆信息输入有误！'));
          return;
        }
        if (this.vdui.isEmpty(ele.plateColor)) {
          callback(new Error('车辆信息输入有误！'));
          return;
        }
      }
      callback();
    };

    return {
      carTypes: '',
      searchForm: {},
      parkId: '',
      reWrite: false,
      spaceList: [],
      carInfos: [],
      objectTypeList: [],
      allPropertyList: [],
      buildingList: [],
      unitList: [],
      roomList: [],
      props: {
        value: 'id',
        label: 'title',
        children: 'children',
        // disabled:true
      },

      addCarMonthShowDialogFlag: false,
      addCarMonthForm: {
        spaceId: '',
        payMoney: '',
      },
      addCarmonthOption: addCarmonthOption,
      regionFirstIdTemp: '',
      addFlag: false,

      buyStartTimeTemp: '',
      buyEndTimeTemp: '',

      tempParkingLotId: '',
      firstDisplayFlag: false,
      form: {
        carInfos: [],
      },
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      propertyId_: '',
      selectionList: [],
      option: {
        height: 'auto',
        stripe: true,
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 18,
        border: true,
        index: true,
        viewBtn: false,
        dialogClickModal: false,
        menuWidth: 300,
        columnBtn: true,
        refreshBtn: true,
        menuSpan: 8,

        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            type: 'tree',
            addDisabled: true,
            editDisabled: true,
            searchSpan: 6,
            dicData: [],
            search: true,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车主姓名',
            prop: 'driverName',
            width: 80,
            maxlength: 20,
            showWordLimit: true,
            searchSpan: 6,
            search: true,
            rules: [
              {
                required: true,
                message: '请输入车主姓名',
                trigger: 'change',
              },
              {
                min: 2,
                max: 20,
                message: '长度在2到20个字之间',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '手机号码',
            prop: 'mobile',
            searchSpan: 6,
            search: true,
            width: 100,
            rules: [
              {
                required: true,
                message: '请输入手机号码',
                trigger: 'change',
              },
              {
                required: true,
                pattern: this.$validation.phone,
                message: '请输入正确的手机号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '身份证号',
            prop: 'idCard',
            hide: true,
            rules: [
              {
                required: false,
                message: '请输入车主身份证号',
                trigger: 'change',
              },
              {
                required: false,
                pattern: this.$validation.idCard,
                message: '身份证号不正确',
                trigger: 'change',
              },
            ],
          },
          {
            label: '性别',
            prop: 'sex',
            type: 'select',
            value: '1',
            width: 70,
            rules: [
              {
                required: true,
                message: '请选择性别',
                trigger: 'change',
              },
            ],
            dicData: [
              { label: '男', value: '1' },
              { label: '女', value: '0' },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
          },
          {
            label: '车辆类别',
            prop: 'driverType',
            type: 'select',
            width: 80,
            clearable: false,
            rules: [
              {
                required: true,
                message: '请选择车辆类别',
                trigger: 'change',
              },
            ],
            dicData: [
              { label: '业主', value: 1 },
              { label: '非业主', value: 2 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
          },
          {
            label: '房产信息',
            prop: 'roomName',
            maxlength: 50,
            slot: true,
            searchSpan: 6,
            search: true,
            showWordLimit: true,
            span: 24,
          },
          {
            label: '车位编号',
            prop: 'parkingSpaceCodes',
            display: false,
          },
          {
            hide: true,
            label: '车位编号',
            prop: 'spaceCodes',
            placeholder: '暂无车位',
            viewDisplay: false,
            formslot: true,
          },
          {
            label: '车牌号',
            prop: 'plateNumber',
            width: 200,
            searchSpan: 6,
            maxlength: 10,
            search: true,
            slot: true,
            addDisplay: false,
          },
          {
            label: '车辆信息',
            prop: 'carInfos',
            type: 'dynamic',
            span: 24,
            rules: [
              {
                required: true,
                message: '请添加车辆信息',
                trigger: 'change',
              },
              { validator: validateCarInfos, trigger: 'blur' },
            ],
            children: {
              page: false,
              align: 'center',
              headerAlign: 'center',
              rowAdd: (done) => {
                done();
              },
              rowDel: (row, done) => {
                if (this.form.carInfos.length == 1) {
                  this.$message.warning('请至少保留一条车辆信息！');
                } else {
                  //如果是已经添加的车辆，直接调用删除接口
                  this.$confirm('确定要删除车辆信息?', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                  })
                    .then(() => {
                      if (row.balance > 0) {
                        this.$message.warning(
                          '车辆【' + row.plateNumber + '】存在余额，不能删除！'
                        );
                        return;
                      }
                      if (row.id) {
                        return removeCar(row);
                      } else {
                        let res = {};
                        res.success = true;
                        return res;
                      }
                    })
                    .then((res) => {
                      if (res.success) {
                        this.$message.success('车辆信息删除成功！');
                        done();
                      } else {
                        this.$message.warning(res.msg);
                      }
                    });
                }
              },
              column: [
                {
                  label: '车牌',
                  prop: 'plateNumber',
                  width: 200,
                  formHeight: 200,
                  clearable: false,
                  rules: [
                    {
                      required: true,
                      message: '请输入车牌',
                      trigger: 'blur',
                    },
                    { min: 1, max: 8, message: '长度请控制在8个字符内！', trigger: 'change' },
                    {
                      required: true,
                      pattern: this.$validation.carPlate,
                      message: '车牌格式不对',
                      trigger: 'blur',
                    },
                  ],
                },
                {
                  label: '车辆类型',
                  prop: 'vehicleType',
                  type: 'select',
                  width: 150,
                  dataType: 'number',
                  dicUrl: 'api/blade-system/dict/dictionary?code=vehicle_type',
                  props: { label: 'dictValue', value: 'dictKey' },
                  rules: [
                    {
                      required: true,
                      message: '请选择车辆类型',
                      trigger: 'change',
                    },
                  ],
                },
                {
                  label: '车牌颜色',
                  prop: 'plateColor',
                  type: 'select',
                  width: 150,
                  dicUrl: 'api/blade-system/dict/dictionary?code=plate_color',
                  dataType: 'string',
                  props: { label: 'dictValue', value: 'dictKey' },
                  rules: [
                    {
                      required: true,
                      message: '请选择车牌颜色',
                      trigger: 'change',
                    },
                  ],
                },
                {
                  label: '备注信息',
                  prop: 'remark',
                  type: 'input',
                  span: 24,
                  slot: true,
                  maxlength: 100,
                  showWordLimit: true,
                  overHidden: true,
                },
              ],
            },
          },
          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            span: 24,
            slot: true,
            minRows: 2,
            maxlength: 100,
            showWordLimit: true,
            overHidden: true,
          },
        ],
      },
      data: [],
      disabledFlag: false,
    };
  },
  watch: {
    'query.parkingLotId'() {
      this.parkId = this.query.parkingLotId;
    },
    'form.parkingLotId'() {
      if (typeof this.form.parkingLotId !== 'undefined' && this.form.parkingLotId !== '') {
        this.form.roomName = '';
        getCarParkspace({ id: this.form.parkingLotId }).then(({ data }) => {
          //const column = this.findObject(this.option.column, 'propertyId');
          console.log(12345878);
          console.log(data);
          if (this.vdui.isNotEmpty(data.areaId)) {
            loadBuildingList({ propertyId: data.areaId }).then((res) => {
              this.buildingList = res.data;
            });
            // lazyBasePropertyTree(data.areaId).then((res) => {
            //   this.buildingList = res.data;

            // });
          } else {
            this.buildingList = [];
            this.unitList = [];
            this.roomList = [];
            this.form.building = '';
            this.form.unitName = '';
            this.form.roomId = '';
          }
        });
        getSpaceList({ parentId: this.form.parkingLotId }).then(({ data }) => {
          this.spaceList = data;
        });
      }
    },
    'addCarMonthForm.carNo'(val) {
      this.carInfos.forEach((e) => {
        if (e.plateNumber == val) {
          this.addCarMonthForm.carType = parseInt(e.vehicleType);
          if (this.vdui.isNotEmpty(this.addCarMonthForm.spaceId)) {
            getcarMonthLastEndTime({ spaceId: this.addCarMonthForm.spaceId, carNo: val }).then(
              ({ data }) => {
                if (this.vdui.isNotEmpty(data)) {
                  this.addCarMonthForm.lastEndTime = data.buyEndTime;
                  if (this.vdui.isNotEmpty(data.newStartTime)) {
                    this.addCarMonthForm.buyStartTime = data.newStartTime + ' 00:00:00';
                  } else {
                    this.addCarMonthForm.buyStartTime =
                      dayjs(new Date()).format('YYYY-MM-DD') + ' 00:00:00';
                  }
                  if (this.vdui.isNotEmpty(data.regions)) {
                    this.addCarMonthForm.regions = data.regions;
                  }
                  this.addCarMonthForm.ruleId = data.ruleId;
                } else {
                  this.addCarMonthForm.buyStartTime =
                    dayjs(new Date()).format('YYYY-MM-DD') + ' 00:00:00';
                  this.addCarMonthForm.ruleId = '';
                  let discountId = this.findObject(this.addCarmonthOption.column, 'discountId');
                  discountId.dicData = ['1'];
                  this.addCarMonthForm.discountId = '';
                  this.addCarMonthForm.regions = this.regionFirstIdTemp;
                  console.log(this.addCarMonthForm.regions);
                }
              }
            );
          }
        }
      });
      setTimeout(() => {
        monthChargeRuleListV2(
          Object.assign({
            spaceId: this.addCarMonthForm.spaceId,
            carType: this.addCarMonthForm.carType,
            carCategory: this.addCarMonthForm.driverType,
          })
        ).then(({ data }) => {
          const column = this.findObject(this.addCarmonthOption.column, 'ruleId');
          column.dicData = data;
        });
      }, 0);
    },
    'addCarMonthForm.cycleNum'() {
      this.initShoudMoney();
    },
    'addCarMonthForm.ruleId'() {
      this.addCarMonthForm.cycleNum = '';
      let discountId = this.findObject(this.addCarmonthOption.column, 'discountId');
      //清空下拉框数据
      discountId.dicData = ['1'];
      this.addCarMonthForm.discountId = '';
    },
    'addCarMonthForm.buyStartTime'() {
      this.addCarMonthForm.buyEndTime = '';
      this.addCarMonthForm.cycleNum = '';
    },
  },
  created() {
    this.option.height = this.bodyHeight - 380;
    getSpaceTree().then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
        spaceColumn.dicData = data.data;
        spaceColumn.value = this.spaceList[0].id;
        spaceColumn.searchValue = this.spaceList[0].id;
        this.query.parkingLotId = this.spaceList[0].id;
        this.searchForm.parkingLotId = this.spaceList[0].id;
        this.tempParkingLotId = this.spaceList[0].id;
        this.$nextTick(() => {
          this.reWrite = true;
        });
      } else {
        this.$nextTick(() => {
          this.reWrite = true;
        });
      }
      this.onLoad();
    });
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document
          .querySelector(
            '#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)'
          )
          .addEventListener('click', () => {
            if (this.option.height == this.bodyHeight - 380) {
              this.option.height = this.bodyHeight - 280;
            } else {
              this.option.height = this.bodyHeight - 380;
            }
            this.$refs.crud.getTableHeight();
          });
      }, 1000);
    });
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkdriver_add, false),
        viewBtn: this.vaildData(this.permission.parkdriver_view, false),
        delBtn: this.vaildData(this.permission.parkdriver_delete, false),
        editBtn: this.vaildData(this.permission.parkdriver_edit, false),
        syncBtn: this.vaildData(this.permission.parkdriver_sync, false),
        add_carMonthBtn: this.vaildData(this.permission.parkdriver_add_carmonth, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    //打开新增月卡车弹框
    openAddCarmonthDialog(row, flag) {
      this.addFlag = true;
      this.addCarMonthShowDialogFlag = true;
      //设置车辆为月卡车
      this.addCarMonthForm.carClass = row.driverType;

      getDetail({ id: row.id }).then(({ data }) => {
        console.log(data);
        this.addCarMonthForm.spaceId = data.parkingLotId;
        this.addCarMonthForm.carNo = data.plateNumber;
        this.addCarMonthForm.customerName = data.driverName;
        this.addCarMonthForm.customerPhone = data.mobile;
        this.addCarMonthForm.areaName = data.roomName;
        this.addCarMonthForm.areaId = data.propertyId;
        this.addCarMonthForm.customerId = data.id;
        this.addCarMonthForm.driverType = data.driverType;
        if (this.vdui.isNotEmpty(data.spaceCodes)) {
          const columnLot = this.findObject(this.addCarmonthOption.column, 'lotNo');
          let lots = [];
          data.spaceCodes.forEach((e) => {
            let item = {
              spaceCode: e,
            };
            lots.push(item);
          });
          columnLot.dicData = lots;
        }

        const columnCarNo = this.findObject(this.addCarmonthOption.column, 'carNo');
        columnCarNo.dicData = data.carInfos;
        this.carInfos = data.carInfos;
        if (this.vdui.isEmpty(this.addCarMonthForm.carNo) && this.vdui.isNotEmpty(data.carInfos)) {
          this.addCarMonthForm.carNo = columnCarNo.dicData[0].plateNumber;
          this.addCarMonthForm.carType = parseInt(columnCarNo.dicData[0].vehicleType);
        }

        //加载上一次续费止期
        getcarMonthLastEndTime({
          spaceId: row.parkingLotId,
          carNo: this.addCarMonthForm.carNo,
        }).then(({ data }) => {
          if (this.vdui.isNotEmpty(data)) {
            this.addCarMonthForm.lastEndTime = data.buyEndTime;
            if (this.vdui.isNotEmpty(data.newStartTime)) {
              this.addCarMonthForm.buyStartTime = data.newStartTime + ' 00:00:00';
            } else {
              this.addCarMonthForm.buyStartTime =
                dayjs(new Date()).format('YYYY-MM-DD') + ' 00:00:00';
            }

            if (this.vdui.isNotEmpty(data.regions)) {
              this.addCarMonthForm.regions = data.regions;
            }
            this.addCarMonthForm.ruleId = data.ruleId;
          } else {
            this.addCarMonthForm.buyStartTime =
              dayjs(new Date()).format('YYYY-MM-DD') + ' 00:00:00';
            console.log(this.addCarMonthForm.buyStartTime);
          }
        });
      });

      //用于新增月卡车页面套餐数据
      setTimeout(() => {
        monthChargeRuleListV2(
          Object.assign({
            spaceId: row.parkingLotId,
            carType: this.addCarMonthForm.carType,
            carCategory: row.driverType,
          })
        ).then(({ data }) => {
          this.carTypes = row.driverType;
          const column = this.findObject(this.addCarmonthOption.column, 'ruleId');
          column.dicData = data;
          // if(row.driverType == 1){
          //     //业主 costSort = 1，2 ，5
          //   column.dicData = data.filter(e=>{
          //     if((e.costSort == 1||e.costSort == 2|| e.costSort == 5)&& e.carType == row.vehicleType){
          //       return e;
          //     }
          //   });
          // }
          // if(row.driverType == 2){
          //     //非业主 costSort = 3，4，5非业主
          //   column.dicData = data.filter(e=>{
          //     if((e.costSort == 3||e.costSort == 4|| e.costSort == 5)&& e.carType == row.vehicleType){
          //       return e;
          //     }
          //   });
          // }
        });
      }, 0);

      //用于新增月卡车页面区域数据
      nodeTreeByParentId(row.parkingLotId).then((res) => {
        const column = this.findObject(this.addCarmonthOption.column, 'regions');
        column.dicData = res.data;

        if (
          this.vdui.isEmpty(this.addCarMonthForm.regions) &&
          this.vdui.isNotEmpty(column.dicData)
        ) {
          if (this.addFlag) {
            this.addCarMonthForm.regions = column.dicData[0].id;

            // 临时区域变量，用于新增清空表单后再次默认选中第一个区域
            this.regionFirstIdTemp = column.dicData[0].id;
          } else {
            this.addCarMonthForm.regions = '';
          }
        }
      });

      if (flag) {
        return;
      }
    },
    //退出新增月卡车
    quitAddCarMonthDialog(form, done) {
      this.addCarMonthShowDialogFlag = false;
      this.carInfos = [];
      this.regionFirstIdTemp = '';
      this.$refs.addCarMonthFormRef.resetForm();
    },

    //新增月卡车保存
    addCarMonthSubmit(form, done) {
      this.$refs.addCarMonthFormRef.validate((valid) => {
        if (valid) {
          if (!form.regions.length) {
            form.regions = '';
          }
          form.buyStartTime = this.dayjs(form.buyStartTime).format('YYYY-MM-DD HH:mm:ss');
          //form.regions=[]?'':form.regions;
          //调用普通新增月卡车
          addCarMonthNew(form).then(
            () => {
              this.onLoad();
              this.$message.success('操作成功!');
              this.addCarMonthShowDialogFlag = false;
              this.$refs.addCarMonthFormRef.resetForm();
              done();
            },
            (error) => {
              done();
            }
          );
        }
      });
    },

    //初始化化应收金额
    initShoudMoney() {
      if (this.vdui.isNotEmpty(this.addCarMonthForm.cycleNum)) {
        if (this.vdui.isEmpty(this.addCarMonthForm.ruleId)) {
          this.$message.error('收费规则不得为空');
          return;
        }
        loadCarPayAmount({
          ruleId: this.addCarMonthForm.ruleId,
          cycleNum: this.addCarMonthForm.cycleNum,
          startTime: this.addCarMonthForm.buyStartTime,
          backAmount: this.addCarMonthForm.backAmount,
          backType: 3,
        }).then(({ data }) => {
          this.addCarMonthForm.shouldMoney = data.shouldAmount;
          this.addCarMonthForm.payMoney = data.shouldAmount;
          this.addCarMonthForm.buyEndTime = data.endTime + ' 23:59:59';
        });
        this.carInfos.forEach((e) => {
          if (e.plateNumber === this.addCarMonthForm.carNo) {
            carMonthRule({
              spaceId: this.addCarMonthForm.spaceId,
              carType: e.vehicleType,
              carCategory: this.carTypes,
              payPeriods: this.addCarMonthForm.cycleNum,
              chargeRuleId: this.addCarMonthForm.ruleId,
            }).then(({ data }) => {
              let discountId = this.findObject(this.addCarmonthOption.column, 'discountId');
              if (this.vdui.isNotEmpty(data)) {
                discountId.dicData = data;
                this.addCarMonthForm.discountId = data[0].id;
              } else {
                try {
                  this.addCarMonthForm.discountId = '';
                  discountId.dicData = ['1'];
                } catch (e) {}
              }
            });
          }
        });
      } else {
        if (!this.addCarMonthForm.shouldMoney) {
          this.addCarMonthForm.shouldMoney = 0;
        }
        if (!this.addCarMonthForm.payMoney) {
          this.addCarMonthForm.payMoney = 0;
        }
        return;
      }
    },

    handleSync() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定下发所选车主信息到对应车场终端?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return syncDrivers({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    // 自定义清空房间信息
    emptyRoom() {
      this.form.building = '';
      this.form.roomId = '';
      this.form.unitName = '';
      this.propertyId = '';
      this.roomName = '';
    },
    rowSave(row, done, loading) {
      row.propertyId = row.roomId;
      if (this.vdui.isEmpty(row.spaceCodes)) {
        //转换成数组
        row.spaceCodes = [];
      }
      let isSubmitFlag = true;
      for (let i = 0; i < row.carInfos.length; i++) {
        if (
          !row.carInfos[i].plateNumber ||
          !row.carInfos[i].plateColor ||
          !row.carInfos[i].vehicleType
        ) {
          this.$message.warning(`请补全车辆信息`);
          isSubmitFlag = false;
          break;
        }
        if (row.carInfos[i].plateNumber.length > 8) {
          // this.$message.warning(`长度请控制在8个字符内！`);
          isSubmitFlag = false;
          break;
        }
      }
      if (!isSubmitFlag) {
        loading();
        return;
      }
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      row.propertyId = row.roomId;
      /*if(this.form.driverType=2){
          this.form.emptyRoom()
        }*/
      let isSubmitFlag = true;
      for (let i = 0; i < row.carInfos.length; i++) {
        if (
          !row.carInfos[i].plateNumber ||
          !row.carInfos[i].plateColor ||
          !row.carInfos[i].vehicleType
        ) {
          this.$message.warning(`请补全车辆信息`);
          isSubmitFlag = false;
          break;
        }
        if (row.carInfos[i].plateNumber.length > 8) {
          // this.$message.warning(`长度请控制在8个字符内！`);
          isSubmitFlag = false;
          break;
        }
      }
      if (!isSubmitFlag) {
        loading();
        return;
      }
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
          setTimeout(function () {
            let rows = document.querySelectorAll('input[placeholder="请输入 车牌"]');
            rows.forEach((ele) => {
              ele.setAttribute('disabled', 'disabled');
            });
          });
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ id: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.$refs.crud.$refs.dialogForm.$refs.tableForm.$el.querySelector(
            '.avue-form__menu'
          ).style.width = '99%';
          this.form = data;
          this.form.roomId = data.room;
          this.form.building = data.buildingId;
          loadRoomList({ propertyId: this.form.building || '' }).then(({ data }) => {
            console.log(data);
            this.roomList = data;
          });
          if ('edit' === type) {
            setTimeout(function () {
              let rows = document.querySelectorAll('input[placeholder="请输入 车牌"]');
              rows.forEach((ele) => {
                ele.setAttribute('disabled', 'disabled');
              });
            });
          }
        });
      } else {
        this.form.parkingLotId = this.query.parkingLotId;
        setTimeout(() => {
          this.$refs.crud.$refs.dialogForm.$refs.tableForm.$el.querySelector(
            '.avue-form__menu'
          ).style.width = '99%';
          console.log(this.query.parkingLotId);
        }, 0);
      }
      if (['add', 'edit'].includes(type)) {
        this.emptyRoom();
      }
      if ('add' === type) {
        this.form.carInfos = [{}];
      }
      done();
    },
    searchReset() {
      this.searchForm.parkingLotId = this.tempParkingLotId;
      this.searchForm.driverName = '';
      this.searchForm.roomName = '';
      this.searchForm.mobile = '';
      this.searchForm.plateNumber = '';
      this.query = this.searchForm;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      if (!this.query.parkingLotId) {
        this.query.parkingLotId = this.parkId;
      }
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      if (!this.query.parkingLotId) {
        return;
      }
      this.loading = true;
      this.parkId = this.query.parkingLotId;
      this.tempParkingLotId = this.query.parkingLotId;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
